controllers.controller('QrcodeController', [
    '$scope', '$state', 'LocaleService', 'constants', 'UserService', 'ErrorService', 'ionicToast', 'Storage', 'API', '$ionicLoading', '$cookies',
    function ($scope, $state, LocaleService, Const, UserService, ErrorService, ionicToast, Storage,  API, $ionicLoading,  $cookies) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.user = UserService.get();
        $scope.paymentMethods = Storage.get('paymentMethods') || [];
        $scope.showAmountSelect = true;
        $scope.constants = Const;
        $scope.depositValue = Storage.get('depositValue');
        $scope.displayCurrency = $scope.user.currency;
        $scope.flagIcon = $scope.user.currency.toLowerCase();
        $scope.method = $state.params.method || '';
        $scope.pspCurrencies = $scope.method.pspCurrencies || [];
        $scope.pspCurrency = $scope.pspCurrencies.length > 0 ? $scope.pspCurrencies[0] : null;
        $scope.config = {
            min: $scope.depositValue.minimum,
            max: $scope.depositValue.maximum,
            visual: $scope.depositValue.visual,
            digits: 0,
            step: 50,
            listAmounts: [],
            pspCurrencies: $scope.pspCurrencies
        };
        $scope.cryptoWallet = {
            qrCode: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
            address: 'N/A',
            transactionId: 'N/A',
            emv: 'N/A'
        };

        var result = [];

        Array(5).fill(null).reduce(function (acc, cur, index) {
            var tmp = Math.ceil(acc * Const.depositMultipliers[index]);
            result.push(tmp);
            return tmp;
        }, $scope.config.visual <= $scope.config.min ? $scope.config.min : $scope.config.visual);

        if (result.length > 0) $scope.config.listAmounts = result;

        $scope.amount = {
            value: $scope.config.visual,
            pspCurrency: $scope.pspCurrency
        };

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        function doPayment() {
            var request = {
                amount: parseInt($scope.amount.value, 10),
                pspCurrency: $scope.amount.pspCurrency || undefined,
                pspName: Const.paymentMethodsBlueprint[$state.params.method.name] || $state.params.method.name,
                remarketing: $cookies.get('remarketing') || ''
            };

            $ionicLoading.show();

            return API.qrcodeDeposit(request)
                .then(checkResponse)
                .then(function (response) {
                    $scope.cryptoWallet.qrCode = response.QRCode;
                    $scope.cryptoWallet.transactionId = response.transactionId;
                    $scope.cryptoWallet.emv = response.emv || 'n/a';
                    $ionicLoading.hide();
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.isError = true;
                    $scope.modal.textTitle = LocaleService.translation.messages.general_error;
                    $scope.modal.textContent = LocaleService.translation.messages.general_error_text;
                    $scope.modal.actionText = $scope.paymentMethods.length > 1 ? LocaleService.translation.try_again : LocaleService.translation.close;
                    $scope.modal.back = $scope.paymentMethods.length > 1 ? 'root.app.wallet' : 'root.app.assets';
                    $scope.modal.state = true;
                })
        }
        $scope.copyPixCode = function() {
            var input = (document.getElementById('pix-code'));
            HTMLCollection.prototype.isPrototypeOf(input) && input.length && (input = input[0]);

            if (input){
                input.select();
                input.setSelectionRange(0, $scope.cryptoWallet.emv.length);
                document.execCommand('copy');
                input.blur();
                window.getSelection().removeAllRanges();

                console.log("copy")

                ionicToast.show($scope.translation.copiedToCB, 'top', false, 5000, '');
            }
        }


        $scope.getUrl = function () {
            return doPayment();
        };

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'QrcodeController',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }
        $scope.$on('$ionicView.beforeEnter', function () {
            if($scope.method.hasOwnProperty("amountRequired") && !$scope.method.amountRequired)  {
                $scope.showAmountSelect = false;
                $scope.amount.value = 1;
                doPayment();
            }
        });
    }
]);
